<template>
  <div>
    <component :is="currentComponent" />
  </div>
</template>

<script>
import Top from '@/views/Top.vue'
// ログインユーザー向けトップ。現在はログイン状態に関わらず Top を表示するため未使用。
// ログイン後トップを再設計する際にコメントを解除して分岐を復活させる。
// import Top4Member from '@/views/Top4Member.vue'
import Top4BeautyOEM from '@/views/Top4BeautyOEM.vue'
// import firebase from 'firebase/app'
import oemConfigs from '@/plugins/oem'

// OEM種別 → トップコンポーネントのマッピング
// 新しいOEMを追加する場合はここにimportとマッピングを追記する
const OEM_TOP_COMPONENTS = {
  Top4BeautyOEM
}

const SITE_OEM = process.env.VUE_APP_SITE_OEM
const oemTopComponentName =
  SITE_OEM && oemConfigs[SITE_OEM] ? oemConfigs[SITE_OEM].topComponent : null

export default {
  name: 'TopCommon',
  components: {
    Top,
    // Top4Member, // 現在は未使用（ログイン関係なく Top を表示）
    ...OEM_TOP_COMPONENTS
  },
  data() {
    return {
      currentComponent: Top
    }
  },
  created() {
    if (oemTopComponentName) {
      this.currentComponent = oemTopComponentName
    } else {
      // ログイン状態に関わらず常に Top を表示
      // （ログインユーザー向けトップ Top4Member は今後別途検討）
      this.currentComponent = 'Top'
    }
  }
}
</script>
